import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { Col, Row, } from "react-bootstrap";
import ReactTable from "react-table";
import debounce from "lodash/debounce";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import DocumentsService from "../../../services/DocumentsService";
import HandleError from "../../../services/HandleError";
import DeleteModal from "../../modals/DeleteModal";
import Materialicon from "../../helpers/Materialicon";
import { hasPermission } from "../../helpers/Permissions";

class DocumentsPage extends Component {
	state = {
		documentToDelete: null,
		isDeleting: false,
		isLoadingTable: true,
		data: [],
		pages: 1,
		tableColumns: [
			{
				Header: "Name",
				accessor: "name",
				Cell: row => <div className="text-center">{row.value}</div>,
				minWidth: 150
			}, {
				Header: "Link",
				accessor: "link",
				Cell: row => <div className="text-center"><a target="_blank" href={row.value}>{row.value}</a></div>,
				minWidth: 250
			}, {
				Header: "Created at",
				accessor: "created_at",
				Cell: row => <div className="text-center">{moment(row.value).format("DD-MM-YYYY")}</div>,
				minWidth: 150
			}, {
				Header: "Updated at",
				accessor: "updated_at",
				Cell: row => <div className="text-center">{moment(row.value).format("DD-MM-YYYY")}</div>,
				minWidth: 150
			}
		]
	}

	componentDidMount = () => {
		const canEditDocument = hasPermission("document.update");
		const canDeleteDocument = hasPermission("document.delete");
		this.setState({
			tableColumns: [...this.state.tableColumns, {
				Header: "Actions",
				accessor: "id",
				filterable: false,
				sortable: false,
				Cell: row => (
					<div className="text-center">
						<a title="Download" target="_blank" href={row.original.link || null}  className="btn-action material-icons btn-download">cloud_download</a>
						{ (canEditDocument && canDeleteDocument) && 
							<React.Fragment>
								<Link title="Edit" to={`/documents/${row.value}/edit`} className="btn-action material-icons btn-edit">edit</Link>
								<button title="Delete" onClick={() => this.documentToDelete(row.original)} className="btn-action material-icons btn-delete">delete</button>
							</React.Fragment>
						}
					</div>
				)
			}]
		});
	}

	getDocuments= (state) => {
		const {pageSize, sorted, filtered, page } = state;
		const data = JSON.stringify({pageSize, sorted, filtered});
		this.setState({ isLoadingTable: true});
		this.documentService.index(page+1, `data=${data}`).then((res) => {
			this.setState({ isLoadingTable:false, data: res.data.data, pages: res.data.last_page, pageState: state });
		}).catch((err) => {
			this.setState({isLoadingTable:false});
			HandleError(err,this);
		});
	}

	documentToDelete = (document) => {
		this.setState({ documentToDelete : {name: document.name, id: document.id} });
	}
	
	deleteDocument = () => {
		if(this.state.documentToDelete) {
			this.setState({ isDeleting: true });
			this.documentService.delete(this.state.documentToDelete.id).then((res) => {
				this.setState({ isDeleting: false });
				NotificationManager.success("Document deleted.", "Success!");
			}).catch((err) => {
				this.setState({ isDeleting: false });
				HandleError(err, this);
			}).then(() => {	
				this.getDocuments(this.state.pageState);		
				this.closeModal();
			});
		}
	}

	closeModal = () => {
		this.setState({
			documentToDelete: null,
			isDeleting: false,
		});
	}

    documentService = new DocumentsService(this);

    render() {
    	const { data, isLoadingTable, pages, tableColumns } = this.state;
    	const canAddDocument = hasPermission("document.create");
    	return (
    		<div className="crud-page documents-page">
    			<div className="container-fluid">
    				<section className="actions">
    					<Row>
    						<Col md={6} sm={6} xs={12}>
    							<h2 className="page-title">All Documents</h2>
    						</Col>
    						{canAddDocument && 
								<Col md={6} sm={6} xs={12}>
									<Link to="documents/create-document" className="pull-right btn-add-big btn btn-default">
										<Materialicon icon="add_circle_outline" /> Add Document
									</Link>
								</Col>
    						}
    					</Row>   
    				</section>
    				<div className="card card-top-border connection-card fadeInLoadUp">
    					<ReactTable
    						columns={tableColumns}
    						manual 
    						data={data}
    						pages={pages} 
    						loading={isLoadingTable}
    						onFetchData={ debounce(this.getDocuments, 400) } 
    						filterable
    						defaultSorted={[{ id: "name", desc: false }]}
    						defaultPageSize={20}
    						className="-highlight"
    					/>
    				</div>   
    			</div>
    			<DeleteModal
    				itemToDelete={this.state.documentToDelete}
    				deleteItem={this.deleteDocument}
    				isDeleting={this.state.isDeleting}
    				closeModal={this.closeModal}
    			/>
    		</div>
    	);
    }
}

export default DocumentsPage;




// WEBPACK FOOTER //
// ./src/components/pages/documents/DocumentsPage.js